// extracted by mini-css-extract-plugin
export default {"intro_img":"Intro_intro_img__NCaNZ"};